<template>
  <div class="languageBox">
    <div
      v-for="item in languages"
      :key="item.index"
      @click="changeLanguage(item.value)"
    >
      <el-button class="languageBtn">
        <div
          class="languageBtnBox"
          :class="[{ active: currentLang === item.value }]"
        >
          <span>{{ item.label }}</span>
        </div>
      </el-button>
    </div>
  </div>
</template>
<script>
import service from "../http/request";

export default {
  data() {
    return {
      languages: [
        {
          label: "ID",
          value: "id",
          selected: false,
        },
        {
          label: "EN",
          value: "en",
          selected: false,
        },
      ],
    };
  },
  inject: ["destyTranslateRef"],
  methods: {
    async changeLanguage(locale) {
      this.$i18n.locale = locale;
      this.$store.commit("setLanguage", locale);
      if (this.$store.state.userInfo !== null) {
        const language = locale === "en" ? "English" : "Bahasa Indonesia";
        service.post("/seller/updateStoreDetail", {
          sellerLocale: language,
        });
      }
      try {
        await this.destyTranslateRef()?.setCommonTranslate?.({
          dataKey: "lang",
          dataValue: locale,
        });
      } catch (error) {
        console.log("setCommonTranslate error", error);
      }
    },
  },
  computed: {
    currentLang() {
      return this.$store.state.language;
    },
  },
};
</script>
<style lang="less" scoped>
.languageBox {
  display: flex;
  align-items: center;
}
.languageBtnBox {
}
.languageBtn {
  background: transparent;
  border: none;
  outline: none;
  color: rgba(0, 0, 0, 0.5);
  padding: 0;
  margin-left: 10px;
  font-family: @font-family-regular;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 150%;
  @media screen and(max-width:960px) {
    font-size: 16px;
    line-height: 150%;
  }
}
.active {
  color: #000000;
}
.languageImg {
  margin-right: 20px;
}
.languageItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    margin-right: 20px;
  }
}
</style>
